<template>
  <div
    class="sale-document-body md__border border-radius bg-color-write p-3 mb-2 expense-card--clickable"
    @click="$emit('onClick', expense)"
  >
    <div class="sale-document-info">
      <div class="sale-document-description d-flex justify-content-between">
        <div class="info">
          <p class="m-0 text-color-primary str-limit-space expense-description">
            {{ expense.description }}
          </p>
          <p class="m-0 expense-assigned" v-if="assignedLabel">
            <i :class="assignedIcon"></i> {{ assignedLabel }}
          </p>
        </div>
        <div class="sale-document-number">
          <h5 class="h5 font-bold expense-amount">
            -${{ formatNum(expense.amount) }}
          </h5>
          <span class="card-date">{{ formatDate(expense.expense_date) }}</span>
        </div>
      </div>
    </div>

    <div
      class="sale-document-actions d-flex justify-content-between align-items-center mt-3"
    >
      <div class="status d-flex align-items-center" style="gap: 6px">
        <span :class="['expense-cat-badge', catClass]">
          <i :class="catIcon"></i> {{ catLabel }}
        </span>
        <span class="expense-type-badge">
          {{
            expense.expense_type === "overhead" ? "Operativo" : "Costo directo"
          }}
        </span>
      </div>
      <div class="next" @click.stop>
        <el-button
          type="text"
          icon="el-icon-delete"
          size="mini"
          class="expense-delete-btn"
          @click="$emit('onDelete', expense)"
        />
      </div>
    </div>
  </div>
</template>

<script>
const CAT_MAP = {
  software: { label: "Software", icon: "el-icon-monitor", cls: "cat-software" },
  accounting: {
    label: "Contabilidad",
    icon: "el-icon-s-finance",
    cls: "cat-accounting"
  },
  materials: { label: "Materiales", icon: "el-icon-box", cls: "cat-materials" },
  subcontract: {
    label: "Subcontrato",
    icon: "el-icon-s-custom",
    cls: "cat-sub"
  },
  hosting: { label: "Hosting", icon: "el-icon-cloudy", cls: "cat-hosting" },
  travel: {
    label: "Viáticos",
    icon: "el-icon-map-location",
    cls: "cat-travel"
  },
  other: { label: "Otro", icon: "el-icon-more", cls: "cat-other" }
};

export default {
  name: "ExpenseCard",
  props: {
    expense: { type: Object, required: true }
  },
  computed: {
    cat() {
      return (
        CAT_MAP[this.expense.category] || {
          label: this.expense.category,
          icon: "el-icon-more",
          cls: "cat-other"
        }
      );
    },
    catLabel() {
      return this.cat.label;
    },
    catIcon() {
      return this.cat.icon;
    },
    catClass() {
      return this.cat.cls;
    },
    assignedLabel() {
      if (this.expense.project) return this.expense.project.name;
      if (this.expense.invoice)
        return `Factura #${this.expense.invoice.number ||
          this.expense.invoice.id}`;
      return null;
    },
    assignedIcon() {
      if (this.expense.project) return "el-icon-folder";
      return "el-icon-document";
    }
  },
  methods: {
    formatNum(val) {
      if (val === null || val === undefined) return "0.00";
      return Number(val).toLocaleString("es-EC", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    formatDate(date) {
      if (!date) return "";
      const clean = date.length > 10 ? date.substring(0, 10) : date;
      const [y, m, d] = clean.split("-").map(Number);
      const months = [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ];
      return `${d} ${months[m - 1]} ${y}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.expense-description {
  font-size: 13.5px;
  font-weight: 500;
}

.expense-assigned {
  font-size: 11px;
  color: #1d9e75;
  font-weight: 500;
  margin-top: 2px !important;

  i {
    margin-right: 3px;
    font-size: 11px;
  }
}

.expense-amount {
  color: #a32d2d !important;
  font-size: 14px;
}

.expense-card--clickable {
  cursor: pointer;
  transition: box-shadow 0.15s, transform 0.1s;
  &:hover {
    box-shadow: 0 3px 12px rgba(45, 43, 85, 0.1);
    transform: translateY(-1px);
  }
}

.expense-delete-btn {
  color: #c0c4cc;
  padding: 4px;
  &:hover {
    color: #f56c6c;
  }
}

.expense-cat-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 9px;
  border-radius: 20px;
  background: #f1efe8;
  color: #5f5e5a;

  i {
    font-size: 12px;
  }

  &.cat-software {
    background: #e6f7f3;
    color: #1d9e75;
  }
  &.cat-accounting {
    background: #e6f7f3;
    color: #1d9e75;
  }
  &.cat-materials {
    background: #f1efe8;
    color: #5f5e5a;
  }
  &.cat-sub {
    background: #faeeda;
    color: #633806;
  }
  &.cat-hosting {
    background: #e6f7f3;
    color: #1d9e75;
  }
  &.cat-travel {
    background: #faeeda;
    color: #633806;
  }
  &.cat-other {
    background: #f1efe8;
    color: #5f5e5a;
  }
}

.expense-type-badge {
  font-size: 10px;
  color: #909399;
  background: #f4f4f5;
  padding: 2px 7px;
  border-radius: 20px;
}
</style>
